export const backoffBaseOptions = {min: 100, max: 30_000, jitter: 0.2};
export const NONE = 'none';
export const SDP_OFFER_IGNORED = 'offer_ignored';
export const APPLICATION_JSON = 'application/json';
export const MAX_RECONNECT_ATTEMPTS = 8;
